import React from 'react'

export default function Plus() {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 47 47" style={{'margin' : '0 10px 0 0'}}>
            <g id="Icon_ionic-ios-add-circle-outline" data-name="Icon ionic-ios-add-circle-outline" transform="translate(-3.375 -3.375)">
                <path id="Path_1" data-name="Path 1" d="M32.769,20.736H24.352V12.319a1.808,1.808,0,1,0-3.615,0v8.417H12.319a1.731,1.731,0,0,0-1.808,1.808,1.75,1.75,0,0,0,1.808,1.808h8.417v8.417a1.751,1.751,0,0,0,1.808,1.808,1.8,1.8,0,0,0,1.808-1.808V24.352h8.417a1.808,1.808,0,0,0,0-3.615Z" transform="translate(4.331 4.331)" fill="#8200f3"/>
                <path id="Path_2" data-name="Path 2" d="M26.875,6.538A20.34,20.34,0,0,1,41.257,41.257,20.34,20.34,0,0,1,12.493,12.493,20.2,20.2,0,0,1,26.875,6.538m0-3.163a23.5,23.5,0,1,0,23.5,23.5,23.5,23.5,0,0,0-23.5-23.5Z" transform="translate(0 0)" fill="#8200f3"/>
            </g>    
            </svg>
        </div>
    )
}
